import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Labels } from '@core/constants/labels';
import { Role } from '@core/models/role.model';
import { Tenant } from '@core/models/tenant.model';
import { AuthService } from '@core/services/auth-service/auth-service.service';
import { TenantService } from '@core/services/tenant-service/tenant-service.service';
import { UserService } from '@core/services/user-service/user-service.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-invite-user-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  providers: [UserService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './invite-user-dialog.component.html',
  styleUrl: './invite-user-dialog.component.scss',
})
export class InviteUserDialogComponent implements OnInit {
  labels = Labels.INVITE_USER_DIALOG;
  roleModel = Role;
  tenants: Tenant[] = [];

  inviteUserForm: FormGroup;

  constructor(
    private authService: AuthService,
    private dialogRef: MatDialogRef<InviteUserDialogComponent>,
    private tenantService: TenantService,
  ) {
    this.inviteUserForm = new FormGroup({
      full_name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      role: new FormControl('', [Validators.required]),
      tenantId: new FormControl('', [Validators.required]),
    });
  }

  async ngOnInit() {
    const currentUser = this.authService.getLoggedUser();
    if (currentUser && currentUser.is_staff) {
      await this.updateTenants();
      this.inviteUserForm.patchValue({
        tenantId: currentUser.tenant.id,
      });
    } else {
      this.inviteUserForm.removeControl('tenantId');
    }
  }

  async updateTenants() {
    try {
      this.tenants = await lastValueFrom(this.tenantService.getTenants());
    } catch (error) {
      console.error('Error updating tenants:', error);
    }
  }

  async onSubmit() {
    if (this.inviteUserForm.valid) {
      try {
        const updatedUser = await lastValueFrom(
          this.authService.createInvitation(this.inviteUserForm.value),
        );
        this.dialogRef.close(updatedUser);
      } catch (error) {
        console.error('Error inviting user:', error);
      }
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
